import React from "react";
import { Dropdown } from "semantic-ui-react";

import { selectColumn } from "components/BaseTableV3/selectColumn";
import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import {
  DepartmentModal,
  DeleteDepartmentModal as _DeleteDepartmentModal,
} from "routes/entity/components/DepartmentsModals";

const EditDepartmentButton = withRoleCheck(DepartmentModal.EditButton, [
  ACL_RELATIONSHIPS.entityDepartment.edit,
]);

const DeleteDepartmentModal = withRoleCheck(_DeleteDepartmentModal, [
  ACL_RELATIONSHIPS.entityDepartment.delete,
]);

/**
 * Get columns configuration for Departments table.
 *
 * Args:
 *     entityId: The entity ID.
 *     departmentModalRef: Reference to the department modal.
 *
 * Returns:
 *     Array of column definitions for the table.
 */
export const getDepartmentsTableColumns = ({
  entityId = null,
  departmentModalRef = null,
  invalidateData = null,
}) => {
  return [
    selectColumn,
    {
      header: "Department ID",
      id: "Department ID",
      accessorKey: "id",
      size: 120,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 200,
    },
    {
      header: <div aria-label="Department Actions"></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CustomDropdown icon="ellipsis horizontal">
          <Dropdown.Menu direction="left">
            <EditDepartmentButton
              department={row.original}
              modalRef={departmentModalRef}
            />
            <DeleteDepartmentModal
              entityId={entityId}
              departmentId={row.original.id}
              onSuccess={invalidateData}
            />
          </Dropdown.Menu>
        </CustomDropdown>
      ),
    },
  ];
};
